(() => {
  if (window.FarazineProgress) { window.FarazineProgress.prepare(); return; }
  const prefix = 'fara:farazine:progress:v1:';
  const sizeKey = 'fara:farazine:reading-size:v1';
  const validEdition = edition => typeof edition === 'string' && /^[a-z0-9][a-z0-9-]{0,63}$/.test(edition);
  const stored = key => { try { return window.localStorage.getItem(key); } catch { return null; } };
  let readingSize = stored(sizeKey) === 'large' ? 'large' : 'regular';

  function validRecord(record) {
    return record && record.version === 1 && typeof record.story === 'string' && record.story.length <= 180 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(record.story)
      && Number.isFinite(record.position) && record.position >= 0 && record.position <= 1
      && Number.isFinite(record.offset) && record.offset >= 0 && record.offset <= 10000000
      && ['panel', 'page'].includes(record.mode) && ['regular', 'large'].includes(record.size)
      && Number.isFinite(record.width) && record.width >= 0 && record.width <= 100000;
  }
  function read(edition) {
    if (!validEdition(edition)) return null;
    try {
      const raw = stored(prefix + edition);
      if (!raw || raw.length > 4000) return null;
      const record = JSON.parse(raw);
      return validRecord(record) ? record : null;
    } catch { return null; }
  }
  function prepare() {
    document.querySelectorAll('[data-farazine-resume-edition]').forEach(link => {
      const edition = link.dataset.farazineResumeEdition;
      const record = read(edition);
      link.hidden = true;
      if (!record || !link.dataset.farazineEditionUrl) return;
      try {
        const url = new URL(link.dataset.farazineEditionUrl, window.location.href);
        if (url.origin !== new URL(window.location.href).origin || url.searchParams.get('view') !== `farazine-${edition}`) return;
        url.searchParams.set('story', record.story);
        url.searchParams.set('resume', '1');
        url.hash = '';
        link.setAttribute('href', url.href);
        link.hidden = false;
      } catch {}
    });
  }
  function write(edition, record) {
    if (!record || typeof record !== 'object') return false;
    const value = {version: 1, story: record.story, position: record.position, offset: record.offset, mode: record.mode, size: record.size, width: record.width};
    if (!validEdition(edition) || !validRecord(value)) return false;
    try { window.localStorage.setItem(prefix + edition, JSON.stringify(value)); } catch { return false; }
    prepare();
    document.dispatchEvent(new Event('farazine:progress'));
    return true;
  }
  function setSize(size) {
    readingSize = size === 'large' ? 'large' : 'regular';
    try { window.localStorage.setItem(sizeKey, readingSize); } catch {}
    return readingSize;
  }
  window.FarazineProgress = {read, write, prepare, getSize: () => readingSize, setSize};
  document.addEventListener('shopify:section:load', prepare);
  window.addEventListener('pageshow', prepare);
  window.addEventListener('storage', event => {
    if (event.key === sizeKey) readingSize = stored(sizeKey) === 'large' ? 'large' : 'regular';
    if (!event.key || event.key.startsWith(prefix)) {
      prepare();
      document.dispatchEvent(new Event('farazine:progress'));
    }
  });
  prepare();
})();
